import React from 'react';
import {useTranslation} from 'gatsby-plugin-react-i18next';
import Typography from 'design-system/src/Components/Typography/Typography.web';
import {Pressable} from 'react-native';
import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Container = styled.div`
  width: '100%';
  maxwidth: 434;
  padding: '0 16px';
  display: 'flex';
  flexdirection: 'column';
  alignitems: 'center';
`;

const SigninLinkContainer = styled.div`
  margin-left: 6px;
`;

interface AlreadyHaveAccountProps {
  onSignInClick: () => void;
}

const AlreadyHaveAccount: React.FC<AlreadyHaveAccountProps> = ({
  onSignInClick,
}) => {
  const {t} = useTranslation('auth');
  return (
    <Container>
      <Row>
        <Typography variant="body3">
          {t('Already have an account ?')}
        </Typography>

        <SigninLinkContainer>
          <Pressable onPress={onSignInClick}>
            <Typography variant="body3" color="primary">
              {t('Sign in')}
            </Typography>
          </Pressable>
        </SigninLinkContainer>
      </Row>
    </Container>
  );
};

export default AlreadyHaveAccount;
